import { formatPortalMessageDateTimeNow } from "../clientPortalTicketListUtils";

let optimisticSeq = 0;

export function isOptimisticPortalMessageId(id) {
  return typeof id === "string" && id.startsWith("portal-temp-");
}

export function createOptimisticPortalTempId() {
  optimisticSeq += 1;
  return `portal-temp-${Date.now()}-${optimisticSeq}`;
}

export function formatPortalMessageTime(date = new Date()) {
  return formatPortalMessageDateTimeNow(date);
}

function attachmentFromFile(file) {
  const type = String(file?.type || "");
  const localUrl = URL.createObjectURL(file);

  if (type.startsWith("image/")) {
    return { type: "image", image: localUrl, _localBlobUrl: localUrl };
  }
  if (type.startsWith("video/")) {
    return { type: "video", video: localUrl, _localBlobUrl: localUrl };
  }
  if (type.startsWith("audio/")) {
    return { type: "audio", audio: localUrl, _localBlobUrl: localUrl };
  }
  return {
    type: "file",
    document: { url: localUrl, name: file?.name || "Arquivo" },
    _localBlobUrl: localUrl,
  };
}

export function buildOptimisticPortalMessage(payload, { tempId }) {
  const now = formatPortalMessageTime();
  const base = {
    id: tempId,
    sender: "client",
    channelLabel: "Portal do cliente",
    createdAt: now,
    sendStatus: "sending",
    _optimistic: true,
    text: "",
    image: null,
    video: null,
    audio: null,
    document: null,
  };

  if (payload._file) {
    const attachment = attachmentFromFile(payload._file);
    const caption = String(payload.message || "").trim();
    return {
      ...base,
      ...attachment,
      text: caption || (attachment.type === "file" ? payload._file?.name || "Arquivo" : ""),
    };
  }

  if (payload._audioURL) {
    const caption = String(payload.message || "").trim();
    return {
      ...base,
      type: "audio",
      audio: payload._audioURL,
      text: caption || "Áudio",
    };
  }

  return {
    ...base,
    type: "text",
    text: String(payload.message || "").trim(),
  };
}

export function revokeOptimisticPortalBlobUrl(message) {
  const url = message?._localBlobUrl;
  if (!url) return;
  try {
    URL.revokeObjectURL(url);
  } catch {
    /* ignore */
  }
}
